import React, { useState, useEffect } from 'react';
import { Form, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import * as accountService from '../../services/account/accountService';
import StandardDrawer from '../../components/common/StandardDrawer';

const AccountPasswordForm = ({ visible, account, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && account) {
      form.resetFields();
      // 设置账号字段的初始值
      form.setFieldsValue({
        loginId: account.loginId
      });
    }
  }, [visible, account, form]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      //构造API请求数据
      const passwordData = {
        loginId: account.loginId,
        password: values.password,
        passwordEncryptType: "0" //固定值
      };
      
      const response = await accountService.changeAccountPassword(passwordData);
      
      if (response.success) {
        message.success(t('account.changePasswordSuccess'));
        onSuccess();
      } else {
        message.error(response.errorMessage || t('account.changePasswordFailed'));
      }
    } catch (error) {
      console.error('Change password failed:', error);
      message.error(error.message || t('account.changePasswordFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <StandardDrawer
      visible={visible}
      onClose={onCancel}
      onOk={handleSubmit}
      title={t('account.passwordTitle')}
      confirmLoading={loading}
      width={480}
      maskClosable={false}
      destroyOnClose={true}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ padding: '24px 0' }}
      >
        <Form.Item
          name="loginId"
          label={t('account.account')}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="password"
          label={<span className="required-label">{t('account.password')}</span>}
          rules={[
            { required: true, message: t('account.passwordRequired') },
            { min: 8, max: 20, message: t('account.passwordLengthRequired') },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,20}$/,
              message: t('account.passwordComplexityRequired')
            }
          ]}
        >
          <Input.Password placeholder={t('common.pleaseInput')} maxLength={20} />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label={<span className="required-label">{t('account.confirmPassword')}</span>}
          dependencies={['password']}
          rules={[
            { required: true, message: t('account.confirmPasswordRequired') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('account.passwordMismatch')));
              },
            }),
          ]}
        >
          <Input.Password placeholder={t('common.pleaseInput')} maxLength={20} />
        </Form.Item>
      </Form>
    </StandardDrawer>
  );
};

export default AccountPasswordForm;